import React from 'react';
import fallbackHeroImage from '../fallback-hero-image.png';

function Header() {
  return (
    <header id="hero-section">
      <div className="hero-background">
        <video autoPlay muted loop playsInline poster={fallbackHeroImage}>
          <source src="/hero-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="hero-content">
        <div className="container">
          <h1>Next-Gen AI Agents. Autonomous. Collaborative. Built for Scale.</h1>
          <p>
            Savage Technologies architects, develops, and deploys high-performance, secure **autonomous AI agents** and multi-agent workflows. Harnessing the computational power of <strong>Google Cloud Platform (GCP)</strong> and <strong>Oracle Cloud Infrastructure (OCI)</strong>, we build cognitive solutions that execute complex business operations, optimize database tasks, and learn continuously.
          </p>
          <a href="#contact-form" className="btn btn-primary smooth-scroll">Deploy Your First Agent</a>
        </div>
      </div>
    </header>
  );
}

export default Header;
